import React, { useMemo } from 'react';
import { Box, Link, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import RequiredDocumentsTotal from '../../detail/RequiredDocumentsHeading/RequiredDocumentsTotal';

export type DossierNotificationsProps = {
    missingDocumentsCount?: number;
    messagesCount?: number;
    totalDocCount?: number;
    linkDocument?: string;
    linkMessages?: string;
};

const DossierNotifications: React.FunctionComponent<DossierNotificationsProps> = function (props) {
    const {
        missingDocumentsCount = 0,
        totalDocCount = 0,
        messagesCount = 0,
        linkDocument,
        linkMessages,
    } = props;
    const { palette } = useTheme();

    const color = useMemo(() => {
        if (messagesCount > 0) {
            return palette.error.main;
        }

        return 'text.gris50';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messagesCount]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '16px',
                alignItems: 'center',
            }}
        >
            <Box
                component={linkDocument ? Link : Box}
                href={linkDocument}
                sx={{
                    color: 'text.gris70',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    textDecoration: 'none',
                }}
            >
                <FaOptionIcon icon={['fasl', 'paperclip']} />
                <RequiredDocumentsTotal
                    missingDocumentsCount={missingDocumentsCount}
                    totalCount={totalDocCount}
                />
            </Box>
            <Box
                component={linkMessages ? Link : Box}
                href={linkMessages}
                sx={{
                    color: 'text.gris70',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    textDecoration: 'none',
                }}
            >
                <FaOptionIcon icon={['fasl', 'message']} />
                <Typography
                    variant="l2dtableCell"
                    component="span"
                    sx={{ color }}
                >
                    {messagesCount}
                </Typography>
            </Box>
        </Box>
    );
};

export default DossierNotifications;
